var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.row.hits?.length
    ? _c("tr", { staticClass: "document-details" }, [
        _c(
          "td",
          {
            staticStyle: { opacity: "0.8", padding: "0.75em" },
            attrs: { colspan: "100" },
          },
          [
            _c("GenericTable", {
              attrs: {
                rows: { rows: _vm.row.hits },
                cols: _vm.cols,
                info: _vm.info,
                header: _vm.cols.hitColumns,
                disabled: true,
                disableDetails: true,
              },
            }),
            _vm._v(" "),
            _vm.row.doc.numberOfHits &&
            _vm.row.doc.numberOfHits > _vm.row.hits.length
              ? _c(
                  "div",
                  { staticClass: "text-muted clearfix col-xs-12 text-center" },
                  [
                    _vm._v(
                      " ( " +
                        _vm._s(_vm.row.doc.numberOfHits - _vm.row.hits.length) +
                        " " +
                        _vm._s(_vm.$t("results.table.moreHiddenHits")) +
                        ") "
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }